import React from 'react';
import allImg from './assets/objective_all.png';
import acquisitionImg from './assets/objective_acquisition.png';
import expansionImg from './assets/objective_expansion.png';
import retentionImg from './assets/objective_retention.png';
import deflectImg from './assets/objective_deflect.png';

export const objectiveIcons = {
  all_png: <img src={allImg} alt="" />,
  acquisition_png: <img src={acquisitionImg} alt="" />,
  expansion_png: <img src={expansionImg} alt="" />,
  retention_png: <img src={retentionImg} alt="" />,
  deflect_png: <img src={deflectImg} alt="" />,
};
